export default "__VITE_ASSET__yKk4DIix__"